<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold pt-2" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <div class="row pt-2">
        <div class="col-12 col-lg-3">
          <span class="d-block pb-2">Gipsfaserplatten</span>
          <button type="button"
            v-for="(item, index) in items.plaster"
            :key="'plaster-' + index"
            :class="['btn btn-sm btn-outline-filter btn-outer-planking-gips', filterUiState('outerPlanking', item.value)]"
            v-on:click="selectValue(item.value)">{{ item.title }}</button>
        </div>
        <div class="col-12 col-lg-3">
          <span class="d-block pb-2">Putzträgerplatte</span>
            <button type="button"
              v-for="(item, index) in items.render"
              :key="'render-' + index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('outerPlanking', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
        </div>
        <div class="col-12 col-lg-3">
          <span class="d-block pb-2">Spanplatte</span>
          <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
            <button type="button"
              v-for="(item, index) in items.chipboard"
              :key="'chipboard-' + index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('outerPlanking', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>              
          </div>
        </div>

        <div class="col-12 col-lg-3">
          <span class="d-block pb-2">Keine</span>
          <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
              <button type="button"
              v-for="(item, index) in items.none"
              :key="'none-' + index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('outerPlanking', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
              
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionOuterPlanking',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Beplankung Außen',
      items: {
        plaster: [
          { title: '12,5 mm', value: 'opg-12' },
          { title: '2 x 12,5 mm', value: 'opg-25' },
          { title: '15 + 18 mm', value: 'opg-33' }
        ],
        render: [
          { title: '12 mm', value: 'opr-12' }
        ],
        chipboard: [
          { title: '16 mm', value: 'opc-16' },
        ], 
        none: [
          { title: 'ohne', value: null }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      let result = this.items.plaster.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.render.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.chipboard.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('outerPlanking', value)

      let category = this.title
      if (this.items.plaster.some(el => el.value === value)) {
          category += '-Gipsfaserplatten'
      }
      else if ( this.items.render.some(el => el.value === value)) {
          category += '-Putzträgerplatte'
      }
      else if ( this.items.chipboard.some(el => el.value === value)) {
          category += '-Spanplatte'
      }

      this.$gtm.trackEvent({
        event: 'filter',
        category: category,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'outerPlanking',
        title: category + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
